export default Object.freeze({
  list: [],
  byDate: [],
  bySiteAndDate: [],
  loading: true,
});
